<template>
  <v-menu
    v-model="visible"
    :close-on-content-click="false"
    left
  >
    <template v-slot:activator="{ on: menu }">
      <slot name="customActivator" v-bind:on="menu">
        <v-tooltip :top="tooltipTop" :bottom="tooltipBottom">
          <template v-slot:activator="{ on: tooltip }">
            <v-badge
              :content="filterCount"
              :value="filterCount"
              color="red"
              offset-x="15"
              offset-y="20"
              class="mx-3"
              overlap
            >
              <v-btn v-on="Object.assign({}, menu, tooltip)" icon><v-icon>mdi-filter</v-icon></v-btn>
            </v-badge>
          </template>
          <span>Filtrar</span>
        </v-tooltip>
      </slot>
    </template>
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>
        <v-responsive>
          <v-col>
            <slot></slot>
          </v-col>
        </v-responsive>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="closeMenu()" text>Cerrar</v-btn>
        <v-btn @click="applyFilter()" :disabled="disableFilterButton" color="primary" text>Filtrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'filter-menu',

  props: {
    tooltipTop: {
      type: Boolean,
      default: true
    },
    tooltipBottom: Boolean,
    nudgeWidth: {
      type: String,
      default: '400'
    },
    title: {
      type: String,
      default: 'Filtrar'
    },
    currentFilter: Object,
    disableFilterButton: Boolean
  },

  data: () => ({
    visible: false,
    filtered: false
  }),

  computed: {
    filterCount () {
      let total = 0
      for (let [llave, attr] of Object.entries(this.currentFilter)) {
        if (llave !== 'estado') {
          if ((!Array.isArray(attr) && (attr || attr === 0)) || (Array.isArray(attr) && attr.length > 0)) {
            ++total
          }
        }
      }
      return total
    }
  },

  methods: {
    applyFilter () {
      this.filtered = true
      this.visible = false
    },
    closeMenu () {
      this.filtered = false
      this.visible = false
    }
  },

  watch: {
    visible (value) {
      if (!value) {
        if (!this.filtered) {
          this.$emit('canceled')
        } else {
          this.$emit('filtered')
        }
      } else {
        this.filtered = false
        this.$emit('showed')
      }
    }
  }
}
</script>
